export default __webpack_public_path__ + "static/media/shape_logo.aceb6475.svg";